module.exports = __webpack_public_path__ + "img/6c.f5958253.png";